import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
// import CONFIG from "./config/config";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const DETAILED_DEV_TOOLS = process.env.REACT_APP_DETAILED_DEV_TOOLS === 'true';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      // Sentry.browserTracingIntegration({
      //   // Ignore firestore/firebase
      //   shouldCreateSpanForRequest: (url) => {
      //     return !url.includes('firestore.googleapis.com') &&
      //         !url.includes('firebase.googleapis.com') &&
      //         !url.includes('googleapis.com');
      //   },
      // }),

      // Sentry.replayIntegration({
      //   // Reduce the recording quality to minimize overhead
      //   maskAllText: true,
      //   maskAllInputs: true,
      //   blockAllMedia: true,
      //   // Skip recording certain network requests
      //   networkDetailAllowUrls: [
      //     (DETAILED_DEV_TOOLS && /^https?:\/\/localhost(:\d+)?/),
      //     // Only record your app's API calls, not Firebase
      //     process.env.REACT_APP_API_URL &&
      //     new RegExp(process.env.REACT_APP_API_URL.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')),
      //   ].filter(Boolean),
      // }),

      // Sentry.browserProfilingIntegration(),
    ],
    // Performance Monitoring
    // tracesSampleRate: 0.1, //  Capture 10% of the transactions
    // profilesSampleRate: 0.1,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: [
    //   (DETAILED_DEV_TOOLS && /^https?:\/\/localhost(:\d+)?/),
    //   /^https?:\/\/(.*\.)?soopra\.ai/, // All soopra subdomains
    // ].filter(Boolean),
    // Session Replay
    // replaysSessionSampleRate: 0.01, // This sets the sample rate at 1%.
    // replaysOnErrorSampleRate: 0.1,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    environment: process.env.NODE_ENV,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const WrappedApp = SENTRY_DSN ? Sentry.withProfiler(App) : App;

root.render(<WrappedApp />);

if (DETAILED_DEV_TOOLS) { reportWebVitals(console.log); }
